export default __webpack_public_path__ + "static/media/medieval-music-wild-boars-inn.a0a6306b.mp3";